// extracted by mini-css-extract-plugin
export default {"root":"ClockDigit_root__dKUIX"};